import React, { Component } from 'react'
// import { Trans } from 'react-i18next';
class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-md-12 col-sm-12 text-center">
              Copyright © 2022 <a href="/">Krypton</a>. Powered by
              <a href="/"> Tron Blockchain</a> All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
